export enum UserRestrictionEnum {
  // bookmark views threshold reached (i.e., 7 of 10)
  BookmarkViewThresholdReached,
  // bookmark views exceeded (i.e., 11 of 10)
  BookmarkViewLimitReached,
  // bookmark save threshold reached (i.e., 7 of 10)
  BookmarkSaveThresholdReached,
  // bookmark saves exceeded
  BookmarkSaveLimitReached,
  // pro account past due
  ProAccountPastDue,
  // team account expipred
  TeamTrailExpired,
  // publish not enabled
  Publish,
}
